/* Bruno's Place: story chapters, keeps the chapter rail in step with the reader */
(() => {
  if (customElements.get('bp-chapters')) return;

  class BpChapters extends HTMLElement {
    connectedCallback() {
      this.links = [...this.querySelectorAll('[data-bp-rail]')];
      this.chapters = [...this.querySelectorAll('[data-bp-chapter]')];
      this.fill = this.querySelector('.bp-ch__rail-fill');
      if (!this.links.length || !this.chapters.length) return;

      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };
      // Horizon scrolls the window; listen on both in case a wrapper scrolls instead
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.onScroll);

      this.links.forEach((link) =>
        link.addEventListener('click', (e) => {
          const target = this.chapters.find((c) => c.dataset.bpChapter === link.dataset.bpRail);
          if (!target) return;
          e.preventDefault();
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          target.querySelector('.bp-ch__heading')?.setAttribute('tabindex', '-1');
          target.querySelector('.bp-ch__heading')?.focus({ preventScroll: true });
        })
      );

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      window.removeEventListener('resize', this.onScroll);
    }

    update() {
      const line = window.innerHeight * 0.4;
      let active = 0;
      this.chapters.forEach((c, i) => {
        if (c.getBoundingClientRect().top <= line) active = i;
      });
      this.links.forEach((l, i) => {
        const on = i === active;
        l.classList.toggle('is-active', on);
        l.classList.toggle('is-past', i < active);
        if (on) l.setAttribute('aria-current', 'step');
        else l.removeAttribute('aria-current');
      });

      if (this.fill) {
        const first = this.chapters[0].getBoundingClientRect();
        const last = this.chapters[this.chapters.length - 1].getBoundingClientRect();
        const total = last.bottom - first.top;
        const done = Math.min(Math.max((line - first.top) / (total || 1), 0), 1);
        this.fill.style.transform = `scaleY(${done})`;
      }
    }
  }

  customElements.define('bp-chapters', BpChapters);
})();
